module.exports = __webpack_public_path__ + "img/12.991c2179.webp";